import { Redirect, resolveRouteParams, useLayoutSearchParams } from "@-/com.npmjs.expo-router";
import { Platform } from "@-/com.npmjs.react-native";
import {
  MorphemePanelsLayout,
  MorphemeReferencePanel,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels.tabs";

// The bare `/browse/morpheme/<glyph>` route. Rendering Reference from the matched index screen keeps
// production SSR and browser hydration on the same route. MorphemePanelsLayout supplies the shared
// morpheme contexts while keeping the card panel out of this route.
export default function BrowseMorphemeIndexRoute() {
  const params = useLayoutSearchParams<{
    morpheme: string | string[];
    tab?: string | string[];
    view?: string | string[];
  }>();
  const resolvedParams = resolveRouteParams(params);

  // Reference is a web presentation. The bare URL still exists for SEO and shareable web links,
  // but Expo Router also registers it in native builds. Guard the route itself so a deep link,
  // restored navigation state, or raw Link can never mount the desktop reference surface on native.
  if (Platform.OS !== "web") {
    return (
      <Redirect
        href={{
          params: resolvedParams,
          pathname: "/(nav)/(app)/browse/morpheme/[morpheme]/(panels)/info",
        }}
      />
    );
  }

  return (
    <MorphemePanelsLayout
      morpheme={params.morpheme}
      morphemeHrefObject={{
        href: "/(nav)/(app)/browse/morpheme/[morpheme]",
        params,
      }}
    >
      <MorphemeReferencePanel />
    </MorphemePanelsLayout>
  );
}
